import { render, staticRenderFns } from "./CarShipManagerView.vue?vue&type=template&id=df386356&"
import script from "./CarShipManagerView.vue?vue&type=script&lang=js&"
export * from "./CarShipManagerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports